export default __webpack_public_path__ + "static/media/left_bt.b2f72a6e.svg";